import { useEffect, useRef } from 'preact/hooks'
import { useResizeObserver } from './useResizeObserver'

export function useScrollPositionKeeper(gridChange) {
  const [setEntry, entry] = useResizeObserver({})
  const contentHeight = useRef(0)

  useEffect(() => {
    if (entry?.contentRect?.height) {
      if (gridChange?.type === 'initial') contentHeight.current = entry.contentRect.height
    }
  }, [entry?.contentRect?.height])

  useEffect(() => {
    gridChange?.type === 'prev' && scrollToTop(contentHeight.current)
  }, [gridChange])

  return { setEntry, entry }
}

function scrollToTop(contentHeight) {
  const currentScrollPosition = window.scrollY
  window.scrollTo({ left: 0, top: currentScrollPosition + contentHeight, behavior: 'instant' })
}
